<script setup lang="ts">
import { FindTagsDocument, type FindTagsQuery, type TagListItemFragment } from "../graphql/types"
import { useAsyncEntitySearch } from "../forms/composables/useAsyncEntitySearch"
import AsyncBadgeCombobox from "../forms/components/AsyncBadgeCombobox.vue"

const modelValue = defineModel<TagListItemFragment[]>({ default: () => [] })

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })

const { items, loading, hasMore, search, loadMore } = useAsyncEntitySearch<FindTagsQuery, TagListItemFragment>({
  queryDocument: FindTagsDocument,
  extract: (r) => r.findTags
})
</script>

<template>
  <AsyncBadgeCombobox
    v-model="modelValue"
    :items="items"
    :loading="loading"
    :has-more="hasMore"
    :search="search"
    :label-fn="(t) => t.text"
    placeholder="Tag suchen..."
    :disabled="disabled"
    @load-more="loadMore"
  />
</template>
